import type {Contact} from "../../_common/types";

export const getContactData = (contacts: Contact[]) => {
  if (contacts && contacts.length > 0) {
    return {
      contactID: contacts[0].contactID,
      contactFirstName: contacts[0].firstName,
      contactLastName: contacts[0].lastName,
    }
  } else return {
    contactID: null,
    contactFirstName: '',
    contactLastName: '',
  };
};